export * from './table-head-fixer.directive';



// WEBPACK FOOTER //
// /app/src/app/directives/table-head-fixer/index.ts